import { Textarea } from '@src/components/ui';
import { InputWithTags } from '@src/components/ui/InputWithTags';
import { isFormValidationError } from '@src/utilities/form';
import { ICommonFormProps } from '../DynamicForm.types';

export function FormTextArea(props: ICommonFormProps) {
    return props.formProps?.withTagOptions ? (
        <div className="grid gap-4">
            <div className="relative">
                <InputWithTags
                    field={props.field!}
                    type="TextArea"
                    label={props.label}
                    data-component-name={props.keyName}
                    help={props.formProps?.help}
                    maxLength={props.formProps?.maxLength}
                    placeholder={props.formProps?.placeholder as string}
                    required={
                        typeof props.registerOptions?.required === 'object'
                            ? Boolean(props.registerOptions.required.value)
                            : Boolean(props.registerOptions?.required)
                    }
                    tagOptions={props.formProps?.tagOptions}
                    error={
                        props.errors
                            ? isFormValidationError(props.errors.type)
                                ? props.errors?.message
                                : `${props.label} ${props.errors.type}`
                            : undefined
                    }
                />
            </div>
        </div>
    ) : (
        <Textarea
            {...({
                label: props.label,
                isRequired:
                    typeof props.registerOptions?.required === 'object'
                        ? Boolean(props.registerOptions.required.value)
                        : Boolean(props.registerOptions?.required),
                error: props.errors
                    ? isFormValidationError(props.errors.type)
                        ? props.errors?.message
                        : `${props.label} ${props.errors.type}`
                    : undefined,
                'data-component-name': props.keyName,
                description: props.formProps?.description,
                className: props.className,
                disabled: props.disabled || false,
                placeholder: props.formProps?.placeholder as string,
                rows: 6,
                ...props.field,
                help: props.formProps?.help,
                maxLength: props.formProps?.maxLength,
                showCount: props.formProps?.maxLength ? true : false,
            } as any)}
        />
    );
}
